import { render, staticRenderFns } from "./CotationSearch.vue?vue&type=template&id=98706a34&scoped=true"
import script from "./CotationSearch.vue?vue&type=script&lang=ts"
export * from "./CotationSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98706a34",
  null
  
)

export default component.exports